import React, { useState, useEffect } from "react";
import { Button, Divider, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import axios from "axios"
import { Auth } from "aws-amplify";
import { CSVLink } from "react-csv";
import { useTranslation } from "react-i18next";

import FilterListIcon from '@mui/icons-material/FilterList';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import Table from "../../TableComponent";

const Region = ({superAdminInfo}) => {
  const [loading, setLoading] = useState(true)
  const [regionData, setRegionData] = useState([])
  const [lang, setLang] = useState(superAdminInfo.test.lang.sort()[0]);
  const [region, setRegion] = useState("");
  const [std, setStd] = useState("All");

  const { t } = useTranslation();
  
  useEffect(() => {
    if(superAdminInfo.test){
      Auth.currentSession()
      .then((data) => {
        const jwtToken = data.idToken.jwtToken;
        
        const getRegionData = async(testId,superAdminId) => {
          try {
            const response =  await axios.get("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/superAdmin/"+superAdminId+"/region?testId="+testId, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': jwtToken
                }
            });
            // console.log("Region Data: ",response.data)
            setRegionData(response.data["region"])
            setLoading(false)
          }
          catch (error) {
            console.log(error)
            setLoading(false)
          }
        }
        getRegionData(superAdminInfo.test ? superAdminInfo.test.testId : null, superAdminInfo.superAdmin.superAdminId)
        
      })
      .catch((err) => console.log(err));
    }
    else alert("Test has not started yet")
    
  }, [superAdminInfo]);
  
  const columns = [
    {
      key: "region",
      headerName: t("commonItems.tableHeader_region"),
      width: 80
    },
    { 
      key: "schoolCount", 
      headerName: t("commonItems.tableHeader_noOfSchools"), 
      width: 80 
    },
    { 
      key: "studentCount", 
      headerName: t("commonItems.tableHeader_studentsCount"), 
      width: 80 
    },
    // {
    //   key: "recCount",
    //   headerName: "Students Tested Count - " + superAdminInfo.allLangs[lang],
    //   width: 80
    // },
    {
      key: "recPercent",
      headerName: t("commonItems.tableHeader_studentsTested") + " - " + superAdminInfo.allLangs[lang] + " (%)",
      width: 120,
      percent: true
    }
  ];

  // if(superAdminInfo?.test?.status === 3) columns.push({
  //   key: "viewPercent",
  //   headerName: "Intervention Material Viewed - " + superAdminInfo.allLangs[lang] + " (%)",
  //   width: 80,
  //   percent: true
  // })

  const headers = [
    { label: "Region", key: "region" },
    { label: "Number of Schools", key: "schoolCount" },
    { label: "Students Count", key: "studentCount" },
    { label: "Students Tested Count - " + superAdminInfo.allLangs[lang], key: "recCount" },
    { label: "Students Tested - " + superAdminInfo.allLangs[lang] + " (%)", key: "recPercent" },
    // { label: "Intervention Material File Count - " + superAdminInfo.allLangs[lang], key: "fileCount" },
    // { label: "Intervention Material View Count - " + superAdminInfo.allLangs[lang], key: "viewCount" },
    // { label: "Intervention Material Viewed - " + superAdminInfo.allLangs[lang] + " (%)", key: "viewPercent" },
  ];

  const handleLangChange = (e) => {
    setLang(e.target.value);
  };
  
  const handleRegionChange = (e) => {
    setRegion(e.target.value);
  };

  const handleStdChange = (e) => {
    setStd(e.target.value);
  };
  
  var filteredRegionData
  if(lang && std==="All"){
    filteredRegionData = regionData
  }
  else filteredRegionData = [...regionData.filter(item => item.std === std)]
  // var filteredRegionData
  // if(region===""){
  //   filteredRegionData = filteredStdRegionData
  // }
  /* hard coded values for ziets */
  if(region==="ZIET BHUBANESWAR"){
    let ziet1 = ["BHUBANESWAR", "GUWAHATI", "KOLKATA", "RANCHI", "SILCHAR", "TINSUKIA"]
    filteredRegionData = [...filteredRegionData.filter(item => ziet1.includes(item.region))]
  }
  else if(region==="ZIET CHANDIGARH"){
    let ziet2 = ["CHANDIGARH", "DEHRADUN", "DELHI", "GURUGRAM", "JAMMU"]
    filteredRegionData = [...filteredRegionData.filter(item => ziet2.includes(item.region))]
  }
  else if(region==="ZIET GWALIOR"){
    let ziet3 = ["AGRA", "BHOPAL", "JABALPUR", "LUCKNOW", "VARANASI"]
    filteredRegionData = [...filteredRegionData.filter(item => ziet3.includes(item.region))]
  }
  else if(region==="ZIET MUMBAI"){
    let ziet4 = ["AHMEDABAD", "JAIPUR", "MUMBAI", "PATNA", "RAIPUR"]
    filteredRegionData = [...filteredRegionData.filter(item => ziet4.includes(item.region))]
  }
  else if(region==="ZIET MYSORE"){
    let ziet5 = ["BENGALURU", "CHENNAI", "ERNAKULAM", "HYDERABAD"]
    filteredRegionData = [...filteredRegionData.filter(item => ziet5.includes(item.region))]
  }
  /* hard coded values for ziets */
  else if(region!==""){
    filteredRegionData = [...filteredRegionData.filter(item => item.region === region)]
  }
  // console.log(regionData)
  // console.log(filteredRegionData)

  var counts = {
    studentCount: 0,
    ...superAdminInfo.test.lang.sort().reduce((acc, lang) => {
      acc[`${lang}RecCount`] = 0; // Create a key for each language with value 0
      return acc;
    }, {})
  };
  if(superAdminInfo && superAdminInfo.test) {
    let langs = superAdminInfo.test.lang.sort()
    counts.studentCount = filteredRegionData.reduce((acc, item) => {
      return acc + item.counts[langs[0]].studentCount
    }, 0)
    
    langs.forEach(lang => {
      counts[`${lang}RecCount`] = filteredRegionData.reduce((acc, item) => {
      return acc + item.counts[lang].recCount
    }, 0)
    });
  }

  return (
    <div className="regionContent innerContent">
      <h2 style={{textAlign: "center", color: "#0288D1", borderRadius: "15px", border: "1px solid"}}>
        {t("superAdmin.region.title")}{superAdminInfo.test ? <span> - {superAdminInfo.test.testName}</span>: ""}
      </h2>
      <div className="countTileContainer">
        <div className="countTile">
          <div className="countTileLeft">{t("commonItems.countTile_StudentCount")}:</div>
          <div className="countTileRight">{counts.studentCount.toLocaleString("hi")}</div>
        </div>
        {superAdminInfo && superAdminInfo.test &&
          superAdminInfo.test.lang.sort().map((lang, i) => {
            return <div className="countTile" key={i}>
                    <div className="countTileLeft">{t("commonItems.countTile_TestedCount")} - {superAdminInfo.allLangs[lang]}:</div>
                    <div className="countTileRight">{counts[`${lang}RecCount`].toLocaleString("hi")}</div>
                  </div>
          })
        }
      </div>
      <div className="filters">
        <div className="forms">
          <h4 style={{display: "flex", justifyContent: "center", alignItems: "center", gap: "0.25rem"}}>
            <FilterListIcon fontSize="small"/>
            <span style={{height: "100%"}}>{t("commonItems.filterLabel")}</span> 
          </h4>
          <FormControl sx={{ m: 1, minWidth: 150}} size="small">
            <InputLabel id="langFilterLabel">{t("commonItems.dropdownLabel_lang")}</InputLabel>
            <Select
              labelId="langFilterLabel"
              id="langFilter"
              value={lang}
              onChange={handleLangChange}
              autoWidth
              label={t("commonItems.dropdownLabel_lang")}
            >
              {superAdminInfo.test &&
                superAdminInfo.test.lang.sort().map((item, i) => {
                  return <MenuItem key={i} value={item}>{superAdminInfo.allLangs[item]}</MenuItem>   
                })
              }
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 80}} size="small">
            <InputLabel id="stdFilterLabel">{t("commonItems.dropdownLabel_class")}</InputLabel>
            <Select
              labelId="stdFilterLabel"
              id="stdFilter"
              value={std}
              onChange={handleStdChange}
              autoWidth
              label={t("commonItems.dropdownLabel_class")}
            >
              <MenuItem value="All">
                All
              </MenuItem>
              {/* getting all unique std values from data */}
              {regionData &&
                [...new Set(regionData.map(item => item.std))].sort((a, b) => a - b).map((item, i) => {
                return <MenuItem key={i} value={item}>{item}</MenuItem>
                })
              }
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 150}} size="small">
            <InputLabel id="regionFilterLabel">{t("commonItems.dropdownLabel_region")}</InputLabel>
            <Select
              labelId="regionFilterLabel"
              id="regionFilter"
              value={region}
              onChange={handleRegionChange}
              autoWidth
              label={t("commonItems.dropdownLabel_region")}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {/* getting all unique region values from data */}
              {[...new Set(regionData.map(item => item.region))].sort().map((item, i) => {
                return <MenuItem key={i} value={item}>{item}</MenuItem>
              })}
              {/* hard coded values for ziets */}
              {superAdminInfo.superAdmin.superAdminId === 24 &&
                [
                  <MenuItem key={1} value="ZIET BHUBANESWAR">ZIET BHUBANESWAR</MenuItem>,
                  <MenuItem key={2} value="ZIET CHANDIGARH">ZIET CHANDIGARH</MenuItem>,
                  <MenuItem key={3} value="ZIET GWALIOR">ZIET GWALIOR</MenuItem>,
                  <MenuItem key={4} value="ZIET MUMBAI">ZIET MUMBAI</MenuItem>,
                  <MenuItem key={5} value="ZIET MYSORE">ZIET MYSORE</MenuItem>
                ]
              }
              {/* hard coded values for ziets */}
            </Select>
          </FormControl>
        </div>
      </div>
      <div className="tabs">
        <Button variant="contained" color="info" startIcon={<FileDownloadIcon />} sx={{ placeSelf: "start" }}>
          <CSVLink 
            data={(std==="All") ?
                [...new Set(filteredRegionData.map(item => item.region))].map(region => {
                  let stdRegions= filteredRegionData.filter(item => item.region === region)
                  let counts = stdRegions.reduce((acc, item) => {
                    return {
                      "schoolCount": acc.schoolCount <= item.schoolCount ? item.schoolCount : acc.schoolCount,
                      "studentCount": acc.studentCount + item.counts[lang].studentCount,
                      "recCount": acc.recCount + item.counts[lang].recCount,
                      "fileCount": acc.fileCount + item.counts[lang].fileCount,
                      "viewCount": acc.viewCount + item.counts[lang].viewCount
                    }
                  }, {"schoolCount": 0, "studentCount": 0, "recCount": 0, "fileCount": 0, "viewCount": 0 })
                  return {
                    ...stdRegions[0],
                    ...counts,
                    "recPercent": counts["recCount"] ? Math.round(counts["recCount"]*100/counts["studentCount"]*100)/100 : 0, 
                    "viewPercent": counts["viewCount"] ? Math.round(counts["viewCount"]*100/counts["fileCount"]*100)/100 : 0
                  }
                })
              :
                filteredRegionData.map(item => {
                  let counts = item.counts[lang]
                  return {
                    ...item,
                    ...counts,
                    "recPercent": counts["recCount"] ? Math.round(counts["recCount"]*100/counts["studentCount"]*100)/100 : 0, 
                    "viewPercent": counts["viewCount"] ? Math.round(counts["viewCount"]*100/counts["fileCount"]*100)/100 : 0
                  }
                })
            } 
            headers={headers} 
            filename={(std !== "All" ? ("Class-" + std + "_" ) : "") + (region ? region : "All") + "-RegionData - " + superAdminInfo.allLangs[lang] + ".csv"}
          >
            {t("commonItems.buttonLabel_csvDownload")}
          </CSVLink>
        </Button>
      </div>
      <Divider />
      <div className="table">
        <Table
          columns={columns}
          tableData={(std==="All") ?
              [...new Set(filteredRegionData.map(item => item.region))].map(region => {
                let stdRegions= filteredRegionData.filter(item => item.region === region)
                let counts = stdRegions.reduce((acc, item) => {
                  return {
                    "schoolCount": acc.schoolCount <= item.schoolCount ? item.schoolCount : acc.schoolCount,
                    "studentCount": acc.studentCount + item.counts[lang].studentCount,
                    "recCount": acc.recCount + item.counts[lang].recCount,
                    "fileCount": acc.fileCount + item.counts[lang].fileCount,
                    "viewCount": acc.viewCount + item.counts[lang].viewCount
                  }
                }, {"schoolCount": 0, "studentCount": 0, "recCount": 0, "fileCount": 0, "viewCount": 0 })
                return {
                  ...stdRegions[0],
                  ...counts,
                  "recPercent": counts["recCount"] ? Math.round(counts["recCount"]*100/counts["studentCount"]*100)/100 : 0, 
                  "viewPercent": counts["viewCount"] ? Math.round(counts["viewCount"]*100/counts["fileCount"]*100)/100 : 0
                }
              })
            :
              filteredRegionData.map(item => {
                let counts = item.counts[lang]
                return {
                  ...item,
                  ...counts,
                  "recPercent": counts["recCount"] ? Math.round(counts["recCount"]*100/counts["studentCount"]*100)/100 : 0, 
                  "viewPercent": counts["viewCount"] ? Math.round(counts["viewCount"]*100/counts["fileCount"]*100)/100 : 0
                }
              })
          }
          orderBy={["recPercent", "viewPercent", "studentCount"]} 
          tableHeight="calc(100vh - 390px)"
          loading={loading}
        />
      </div>
    </div>
  );
};

export default Region;
